import { useInfiniteQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getLibraryListing } from "../../services/portalAluno/library/libraryService";
import { PORTAL_LISTING_PAGE_SIZE } from "../../config/portalAluno/constants";
import type {
  ContentListingPageData,
  LibrarySectionConfig,
} from "../../@types/portalAluno";
import type { ApplicationState } from "../../store";

export const portalLibraryListingQueryKey = (
  idUsuario?: number,
  apiType?: string
) => ["portal-aluno", "biblioteca", "listagem", idUsuario, apiType];

const useLibraryListing = (section?: LibrarySectionConfig) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useInfiniteQuery<ContentListingPageData>({
    enabled: Boolean(section && idUsuario),
    queryKey: portalLibraryListingQueryKey(idUsuario, section?.apiType),
    queryFn: ({ pageParam = 0 }) =>
      getLibraryListing(section as LibrarySectionConfig, pageParam),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.itemCount < PORTAL_LISTING_PAGE_SIZE
        ? undefined
        : allPages.length * PORTAL_LISTING_PAGE_SIZE,
  });
};

export default useLibraryListing;
